import CustomListItem from './CustomListItem';
import { styled, useTheme, List } from '@mui/material';
import { DefaultSelectedItem } from '../MobileMenu';
import { SubmenuProps } from '../SubMenus';

export interface NestedListProps {
  nestedList: SubmenuProps[];
  setSelectedMenu?: React.Dispatch<React.SetStateAction<DefaultSelectedItem>>;
  selectedMenu?: DefaultSelectedItem;
  closeFunction: () => void;
}

const NestedList: React.FC<NestedListProps> = ({ nestedList, selectedMenu, setSelectedMenu, closeFunction }) => {
  const theme = useTheme();
  return (
    <StyledList sx={{ width: '100%', maxWidth: 360, backgroundColor: theme.palette.background.default }} aria-labelledby="nested-list-subheader">
      {nestedList.map((nestedItem) => (
        <CustomListItem
          {...nestedItem}
          setSelectedMenu={setSelectedMenu}
          selectedMenu={selectedMenu}
          key={nestedItem.buttonTitle}
          closeFunction={closeFunction}
        />
      ))}
    </StyledList>
  );
};

export default NestedList;

const StyledList = styled(List)(({ theme }) => ({
  '& .MuiListItemText-root ': {
    fontWeight: 600, // Change label font-weight
    color: theme.palette.text.secondary,
  },

  '& .MuiListItemIcon-root': {
    fontWeight: 600, // Change label font-weight
    color: theme.palette.text.secondary,
  },
  '& .MuiSvgIcon-root': {
    fontWeight: 600, // Change label font-weight
    color: theme.palette.text.secondary,
    fontSize: 24,
  },
  '& .MuiList-root': {
    paddingLeft: 22,
  },
}));
